import Big from 'big.js';
import axios from 'smg/axios';
import * as hyejoo from 'smg/customer-api/hyejoo';
import { HandleRequestError } from 'smg/errors';
import * as models from 'smg/models';

export async function GetMoldFee(product: string, lineItemTypeID: string, lineItemTypeSizeID: string, width: number, height: number, quantity: number): Promise<Big> {
    let baseMoldFee = Big(0);

    await axios.get<hyejoo.ChildLineItems>('/child-line-items', {
        params: {
            'q': `lineItem:"${product}" mold:yes`,
            'data': 'lineItemID,networkChildLineItem,childLineItemOptions,name,pluralName',
            'width': width,
            'height': height,
            'quantity': quantity,
            'lineItemTypeID': lineItemTypeID,
            'lineItemTypeSizeID': lineItemTypeSizeID,
        },
    }).then(resp => {
        for (const childLineItem of resp.data.childLineItems) {
            if (childLineItem.id === models.ChildLineItemID.CHILD_LINE_ITEM_PIN_MOLD_FEE) {
                baseMoldFee = Big(childLineItem.networkChildLineItem?.price || '0');
            }

            if (childLineItem.childLineItemOptions) {
                for (const childLineItemOption of childLineItem.childLineItemOptions) {
                    if (childLineItemOption.id === models.ChildLineItemOptionID.CHILD_LINE_ITEM_OPTION_COIN_MOLD_FEE_NEW_BOTH_SIDES ||
                        childLineItemOption.id === models.ChildLineItemOptionID.CHILD_LINE_ITEM_OPTION_MEDAL_MOLD_FEE_NEW_BOTH_SIDES
                    ) {
                        baseMoldFee = Big(childLineItemOption.networkChildLineItemOption?.price || '0');
                    }
                }
            }
        }
    }).catch(err => {
        HandleRequestError(err);
        throw err;
    });

    return baseMoldFee;
}